import { company } from '../config/company';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container hero__inner">
        <p className="hero__company">{company.name}</p>
        <h1 className="hero__slogan">{company.slogan}</h1>
        <p className="hero__description">{company.description}</p>
        <div className="hero__actions">
          <a className="hero__button" href="#products">
            Explore Our Products
          </a>
          <a className="hero__button hero__button--ghost" href="#about">
            About Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
